import { ActionsUnion, createAction } from 'spw-redux/types';
import { ProjectSlimForList, ProjectsSortingParams } from '../projects/types';
import {
  ClientForm,
  ClientListItemVM,
  ClientsSortBy,
  IndustryListItemVM,
  ClientDetailVM,
  ProjectsSortBy,
} from './types';

export const CLEAN_CLIENT_DETAIL = 'clients/CLEAN_CLIENT_DETAIL';

export const GET_CLIENT = 'clients/GET_CLIENT';
export const GET_CLIENT_SUCCEEDED = 'clients/GET_CLIENT_SUCCEEDED';
export const GET_CLIENT_FAILED = 'clients/GET_CLIENT_FAILED';

export const GET_CLIENTS = 'clients/GET_CLIENTS';
export const GET_CLIENTS_SUCCEEDED = 'clients/GET_CLIENTS_SUCCEEDED';

export const GET_INDUSTRIES = 'clients/GET_INDUSTRIES';
export const GET_INDUSTRIES_SUCCEEDED = 'clients/GET_INDUSTRIES_SUCCEEDED';

export const GET_PROJECTS_FOR_SELECTED_CLIENT =
  'clients/GET_PROJECTS_FOR_SELECTED_CLIENT';
export const GET_PROJECTS_FOR_SELECTED_CLIENT_SUCCEEDED =
  'clients/GET_PROJECTS_FOR_SELECTED_CLIENT_SUCCEEDED';
export const GET_PROJECTS_FOR_SELECTED_CLIENT_FAILED =
  'clients/GET_PROJECTS_FOR_SELECTED_CLIENT_FAILED';

export const CREATE_CLIENT = 'clients/CREATE_CLIENT';
export const CREATE_CLIENT_SUCCEEDED = 'clients/CREATE_CLIENT_SUCCEEDED';
export const CREATE_CLIENT_FAILED = 'clients/CREATE_CLIENT_FAILED';

export const DELETE_CLIENT = 'clients/DELETE_CLIENT';
export const DELETE_CLIENT_FAILED = 'clients/DELETE_CLIENT_FAILED';
export const DELETE_CLIENT_SUCCEEDED = 'clients/DELETE_CLIENT_SUCCEEDED';

export const UPDATE_CLIENT = 'clients/UPDATE_CLIENT';
export const UPDATE_CLIENT_FAILED = 'clients/UPDATE_CLIENT_FAILED';
export const UPDATE_CLIENT_SUCCEEDED = 'clients/UPDATE_CLIENT_SUCCEEDED';

export const cleanClientDetail = () => createAction(CLEAN_CLIENT_DETAIL);

export const getClient = (clientId: number, sortBy: ProjectsSortBy) =>
  createAction(GET_CLIENT, { clientId, sortBy });

export const getClientSucceeded = (clientDetail: ClientDetailVM) =>
  createAction(GET_CLIENT_SUCCEEDED, { clientDetail });

export const getClientFailed = () => createAction(GET_CLIENT_FAILED);

export const getClients = (
  industryId?: number,
  name?: string,
  sortBy: ClientsSortBy = { column: 'name', direction: 'ASC' },
  page = 1,
  itemsPerPage = 9999
) =>
  createAction(GET_CLIENTS, { industryId, name, sortBy, page, itemsPerPage });

export const getClientsSucceeded = (
  clients: ClientListItemVM[],
  sortBy: ClientsSortBy
) =>
  createAction(GET_CLIENTS_SUCCEEDED, {
    clients,
    sortBy,
  });

export const getIndustries = () => createAction(GET_INDUSTRIES);

export const getIndustriesSucceeded = (industries: IndustryListItemVM[]) =>
  createAction(GET_INDUSTRIES_SUCCEEDED, { industries });

export const getProjectsForSelectedClient = (
  clientId: number,
  sort: ProjectsSortingParams,
  page = 1,
  itemsPerPage = 30
) =>
  createAction(GET_PROJECTS_FOR_SELECTED_CLIENT, {
    clientId,
    sort,
    page,
    itemsPerPage,
  });
export const getProjectsForSelectedClientSucceeded = (payload: {
  projects: ProjectSlimForList[];
  total: number;
}) => createAction(GET_PROJECTS_FOR_SELECTED_CLIENT_SUCCEEDED, payload);
export const getProjectsForSelectedClientFailed = () =>
  createAction(GET_PROJECTS_FOR_SELECTED_CLIENT_FAILED);

export const createClient = (form: ClientForm) =>
  createAction(CREATE_CLIENT, { form });

export const createClientFailed = () => createAction(CREATE_CLIENT_FAILED);

export const createClientSucceeded = (client: ClientListItemVM) =>
  createAction(CREATE_CLIENT_SUCCEEDED, { client });

export const deleteClient = (clientId: number) =>
  createAction(DELETE_CLIENT, { clientId });

export const deleteClientFailed = () => createAction(DELETE_CLIENT_FAILED);

export const deleteClientSucceeded = () =>
  createAction(DELETE_CLIENT_SUCCEEDED);

export const updateClient = (params: {
  form: {
    clientId: number;
    image?: string;
    industryId?: number;
    name?: string;
  };
  onSuccess?: () => void;
}) => createAction(UPDATE_CLIENT, params);

export const updateClientFailed = () => createAction(UPDATE_CLIENT_FAILED);

export const updateClientSucceeded = (clientDetail: ClientDetailVM) =>
  createAction(UPDATE_CLIENT_SUCCEEDED, { clientDetail });

export const actions = {
  cleanClientDetail,
  getClient,
  getClientFailed,
  getClientSucceeded,
  getClients,
  getClientsSucceeded,
  getIndustries,
  getIndustriesSucceeded,
  getProjectsForSelectedClient,
  getProjectsForSelectedClientSucceeded,
  getProjectsForSelectedClientFailed,
  createClient,
  createClientFailed,
  createClientSucceeded,
  deleteClient,
  deleteClientFailed,
  deleteClientSucceeded,
  updateClient,
  updateClientFailed,
  updateClientSucceeded,
};

export type Actions = ActionsUnion<typeof actions>;
